var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00422 2.78852C5.5787 1.25108 4.04677 0.301478 2.53081 0.807124C1.54313 1.13654 0.941894 1.75112 0.742582 2.57085C0.557324 3.33278 0.750417 4.15502 1.0503 4.88165C1.65421 6.34494 2.84947 7.79466 3.5262 8.4719C4.18734 9.13353 5.63496 10.334 7.10101 10.9434C7.82891 11.246 8.65421 11.4425 9.41965 11.2576C10.2434 11.0587 10.8611 10.4544 11.1923 9.45979C11.6972 7.94389 10.7494 6.41078 9.21225 5.98471L9.21224 5.98471C8.16157 5.69349 7.05973 5.97118 6.30778 6.64607C6.13128 6.50939 5.96153 6.3601 5.79964 6.19809C5.63696 6.03529 5.48711 5.86451 5.34996 5.6869C6.01957 4.93468 6.29417 3.83616 6.00422 2.78852L6.00422 2.78852Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.05ab8544d9119908ff58d0429ea962d9.svg";
export { ForwardRef as ReactComponent };